import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    standalone: false,
    selector: 'dpo-advisor',
    templateUrl: './dpo-advisor.component.html',
    styles: [':host { display: block; height: calc(100vh - 2px); }', '.dpo-advisor__iframe { border: 0; width: 100%; height: 100% }'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DpoAdvisorComponent {}
